// extracted by mini-css-extract-plugin
var _1 = "AuthLayout-moduleAuthLayout__b3Mki";
var _2 = "AuthLayout-modulescrollContainer__jk7EI ScrollContainer-moduleScrollContainer__LHyVB";
export { _1 as "AuthLayout", _2 as "scrollContainer" }
